<template>
  <b-form class="survey-form">
    <b-container>
      <b-row class="border-bottom border-muted pb-3">
        <b-col lg="9" cols="9">
          <b-form-group label="Question" :label-for="`input-question-${index}`">
            <b-input
              :id="`input-question-${index}`"
              placeholder="Type your question here"
              required
              v-model="question.question"
              :maxlength="questionMaxLength"
              @keypress.native="filterAlphaNumericPunctuations"
              :readonly="isReadOnly"
              :state="isInvalid('question')"
            ></b-input>
            <b-form-invalid-feedback :state="isInvalid('question')">
              {{ errorMessage("question") }}
            </b-form-invalid-feedback>
            <slot name="image-render"></slot>
          </b-form-group>
        </b-col>
        <b-col lg="1" cols="1">
            <div :style="{ paddingBottom: '30px' }"></div> 
            <slot name="right-action-question-input"></slot>
        </b-col>
        <b-col>
          <b-form-group label="Gigya Pairs" v-if="isUcoin">
            <b-input
              v-model="question.gigya_question_id"
              type="text"
            ></b-input>
          </b-form-group>
        </b-col>
      </b-row>
   
      <b-row class="mt-3 mb-2">
        <b-col lg="9"> Answer </b-col>
        <b-col lg="1">
        </b-col>
        <b-col v-if="isUcoin"> Gigya Pairs </b-col>
      </b-row>
      <b-row
        v-for="(element, key) in contents.elements"
        :key="key"
        class="mb-4"
      >
        <b-col cols="9">
          
          <b-input
            placeholder="Your Answer"
            required
            v-model="contents.elements[key]"
            :maxlength="answerMaxLength"
            @keypress.native="filterAlphaNumericPunctuations"
            :readonly="isReadOnly"
            :state="isInvalid(`answer_${key}`)"
          />
          <b-form-invalid-feedback :state="isInvalid(`answer_${key}`)">
            {{ errorMessage(`answer_${key}`) }}
          </b-form-invalid-feedback>
          <!-- {{contents.images[key] }} -->
          <ImageRender class="mt-3" v-if="contents.images[key].image && question.question_type === 'multiple_choice'" :showCloseButton="!isReadOnly"  :imgBase64="contents.images[key].image" :imageKey="key" :showImageContainer="contents.images[key].showImage"  @close="deleteImageData(key)"></ImageRender>
        </b-col>
        <b-col cols="1" v-if="question.question_type === 'multiple_choice' && !isReadOnly"  >
            <ImageFormAnswer @ImageData="getImageData" :showAddImageButton="!contents.images[key].image" @showDeleteQuestionElementModal="showDeleteQuestionElementModal(key)" :imageKey="key" :idPopup="Math.random()"  :contentElementsLength="contents.elements.length" :showDeleteButton="true" componentKey="answerImage" @reload="reloadComponent"></ImageFormAnswer>  
        </b-col>
        <b-col cols="1" v-if="(question.question_type === 'checkbox' || question.question_type === 'dropdown') && !isReadOnly"  >
            <ImageFormAnswer @ImageData="{}" :showAddImageButton="false" @showDeleteQuestionElementModal="showDeleteQuestionElementModal(key)" :imageKey="key" :idPopup="Math.random()"  :contentElementsLength="contents.elements.length" :showDeleteButton="true" componentKey="none" @reload="reloadComponent"></ImageFormAnswer>  
        </b-col>
        <b-col v-if="isUcoin">
          <b-form-input type="text"
            v-model="contents.gigya_answer_ids[key]"
            v-if="isUcoin"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="!isReadOnly">
        <b-col>
          <b-button
            variant="primary btn-add-link"
            @click.prevent="
              $root.$emit('multiple-choice-add-field', {
                pageIndex: index.split('-')[0],
                questionIndex: index.split('-').pop(),
                question_type: question.question_type,
                question_uuid: question.uuid,
              });
              addAnswerElement();
            "
            :disabled="contents.elements.length === 99"
          >
            Add Answer
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <!-- <b-col lg="4" v-if="question.question_type === 'checkbox'">
          <b-form-group
            label="Limit responses"
            :label-for="`input-limit-${index}`"
          >
            <b-input
              :id="`input-limit-${index}`"
              placeholder="0"
              required
              v-model="contents.limit"
              :readonly="isReadOnly"
              maxlength="2"
              @keypress.native="filterNumeric"
              :state="isInvalid('limit')"
            ></b-input>
            <b-form-invalid-feedback :state="isInvalid('limit')">
              {{ errorMessage("limit") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col> -->
        <b-col lg="4">
          <b-form-group label="Width" :label-for="`input-width-${index}`">
            <b-select
              v-model="contents.width"
              :options="selectWidthOptions"
              :id="`input-width-${index}`"
              :disabled="isReadOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="1">
          <b-form-group
            label="Visible"
            :label-for="`checkbox-visible-${index}`"
          >
            <b-checkbox
              v-model="contents.visible"
              :id="`checkbox-visible-${index}`"
              class="ml-3 mt-3"
              :disabled="isReadOnly"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="2">
          <b-form-group
            label="Required"
            :label-for="`checkbox-required-${index}`"
          >
            <b-checkbox
              v-model="contents.required"
              :id="`checkbox-required-${index}`"
              class="ml-3 mt-3"
              :disabled="isReadOnly"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3 pt-3 border-top border-muted">
        <b-col lg="3" class="ml-auto">
          <div class="d-flex flex-row justify-content-end">
            <b-button
              variant="link"
              class="text-danger font-weight-bold mr-2"
              @click.self="showConfirmCancelQuestionModal"
              :disabled="isReadOnly"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-save"
              @click.self="validateFields"
              :disabled="isReadOnly"
            >
              Save
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
      <ImageUploadAnswer
          :initialValue="imageInitialValue"
          :aspectRatio="imageAspectRatio" 
          :fileName="imageFileName"
          :imageKey="currentImageKey"
          :fileType="imageFileType"
          :rawImageFile="imageRawFile"
          :imageWidth="setImageWidth"
          :imageHeight="setImageHeight"
          componentKey="answerImage"
          @newImageData="getNewImageData"
          @clearImage="deleteImageData(currentImageKey)"
          @closeModal="isCropperClose"
        />
  </b-form>
  
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import notification from "@/services/notification";
import ImageFormAnswer from "@/components/survey/ImageFormAnswer.vue";
import ImageUploadAnswer from "@/components/survey/ImageUploadAnswer.vue";
import ImageRender from "@/components/survey/ImageRender.vue";

export default {
    components: {
      ImageFormAnswer,
      ImageUploadAnswer,
      ImageRender
  },
    name: "MultipleChoiceForm",
    data() {
        return {
            selectedWidth: "full",
            selectWidthOptions: [
                { value: "full", text: "Full" },
                { value: "half", text: "Half" }
            ],
            questionMaxLength: 350,
            answerMaxLength: 350,
            currentImageKey: 0,
            imageInitialValue: null,
            imageAspectRatio: 0,
            imageFileName: '',
            imageFileType: '',
            imageRawFile: null,
            setImageWidth: '',
            setImageHeight: ''
            
        };
    },
    
    computed: {
        ...mapGetters("surveys", ["isLoading", "errors", "isReadOnly", "isUcoin"])
    },
    
    props: ["pageId", "question", "contents", "index"],
    
    methods: {
        ...mapMutations("surveys", ["setQuestionProperties", "setErrors"]),
        validateFields() {
            const errors = {};
            if (!this.question.question)
                errors["question"] = "Question is required";

            if (
                this.question.question &&
                this.isNotAlphaNumericPunctuations(this.question.question)
            ) {
                errors["question"] =
                    "Only alpha numeric with punctuation characters are allowed";
            }
            this.question.contents.elements.map((field, index) => {
                if ((!field || this.isNotAlphaNumericPunctuations(field)) && 
                    (!this.contents.images[index] || this.contents.images[index].image === "")) {
                    errors[`answer_${index}`] = "Answer must contain valid text or an image";
                } else if(field) {
                  const answer = this.question.contents.elements.filter((element, i) => i !== index && (element.trim()).toLowerCase() === (field.trim()).toLowerCase());
                  if (answer.length > 0) {
                    errors[`answer_${index}`] = "Each answer must be unique. Please enter a different response.";
                  }
                }
            });

            this.contents.images.map((image, index) => {
                if ((!image || image.image === "") && 
                    (!this.question.contents.elements[index] || this.isNotAlphaNumericPunctuations(this.question.contents.elements[index]))) {
                    errors[`answer_${index}`] = "Answer must contain valid text or an image";
                }
            });

            if (
                this.question.question_type === "checkbox" &&
                this.question.contents.limit &&
                this.isNotNumeric(this.question.contents.limit)
            )
                errors["limit"] = "Only numeric characters are allowed";

            this.setErrors(errors);
            if (Object.keys(errors).length === 0)
                this.showConfirmSaveQuestionModal();
            else notification.warning("Oops, cannot save question.");
        },
        showDeleteQuestionElementModal(elementIndex) {
            this.setQuestionProperties({
                pageIndex: this.index.split("-")[0],
                questionIndex: this.index.split("-").pop(),
                elementIndex: elementIndex,
                page_uuid: this.pageId,
                question_uuid: this.question.uuid,
                question_type: this.question.question_type
            });
            this.$root.$emit(
                "bv::show::modal",
                "delete-question-element-modal"
            );
        },
        showConfirmSaveQuestionModal() {
            this.setQuestionProperties({
                type: "save",
                pageIndex: this.index.split("-")[0],
                questionIndex: this.index.split("-").pop(),
                question_type: this.question.question_type,
                page_uuid: this.pageId,
                question_uuid: this.question.uuid
            });
            this.$root.$emit(
                "bv::show::modal",
                "confirm-save-cancel-question-modal"
            );
        },
        showConfirmCancelQuestionModal() {
            this.setQuestionProperties({
                type: "cancel",
                pageIndex: this.index.split("-")[0],
                questionIndex: this.index.split("-").pop(),
                question_type: this.question.question_type,
                page_uuid: this.pageId,
                question_uuid: this.question.uuid
            });
            this.$root.$emit(
                "bv::show::modal",
                "confirm-save-cancel-question-modal"
            );
        },
        isNotAlphaNumericPunctuations(input) {
            return /[^A-Za-z0-9 ,.!?'":()\s\-]+/g.test(input);
        },
        filterAlphaNumericPunctuations(e) {
            if (
                this.isNotAlphaNumericPunctuations(
                    String.fromCharCode(e.keyCode)
                )
            )
                e.preventDefault();
        },
        isNotNumeric(input) {
            return /[^0-9]/g.test(input);
        },
        filterNumeric(e) {
            if (this.isNotNumeric(String.fromCharCode(e.keyCode)))
                e.preventDefault();
        },
        isInvalid(field) {
            if (this.errors === null) {
                return null;
            } else {
                return !Object.keys(this.errors).includes(field)
                    ? null
                    : !Object.keys(this.errors).includes(field);
            }
        },
        errorMessage(field) {
            if (this.errors === null) {
                return "";
            } else if (Object.keys(this.errors).includes(field)) {
                return Array.isArray(this.errors[field])
                    ? this.errors[field].join(" ")
                    : this.errors[field];
            }
        },
        getImageData(data) {
            this.imageInitialValue = data.image;
            this.imageAspectRatio = data.aspectRatio;
            this.imageFileName = data.fileName;
            this.imageFileType = data.fileType;
            this.currentImageKey = data.key;
            this.imageRawFile = data.rawFile;
            this.setImageWidth = data.width
            this.setImageHeight = data.height
            this.contents.images[data.key] = data

          },
          deleteImageData(key) {
              this.$nextTick(() => {
                this.contents.images[key] = { "key": key, "image": "", "aspectRatio": "", "prefix": "", "width": "", "height": "", "base64": "", "fileName": "", "fileType": "", "showImage": false };
                this.$emit("reload")
              });
        },
        addAnswerElement() {
          this.$emit("reload");
        },
        getNewImageData(data) {
            this.$nextTick(() => {
                  this.contents.images[data.key] = {
                      ...this.contents.images[data.key], 
                      prefix: data.prefix, 
                      base64: data.base64, 
                      image: data.image,
                      showImage: data.showImage
                    };
                    this.$emit("reload");
                });
          
        },
        isCropperClose(data) {
            this.$nextTick(() => {
                    this.contents.images[data.key] = {
                        ...this.contents.images[data.key], 
                        showImage: data.showImage, 
                      };
                      this.$emit("reload");
                  });
            
      },
      reloadComponent() { 
        this.$emit("reload");
        console.log('reloadComponent')
      }


    }
};
</script>

<style>
</style>
